import React from "react";

import { GustoConnectedCompanyMetadata } from "@common/types/gustoConnection";
import { ExtendedFinancialAccount } from "@lib/financialAccount";
import { AccountDetailsField } from "./AccountDetailsField";

interface AccountDetailsProps {
    account: ExtendedFinancialAccount;
}

export const GustoAccountDetails: React.FC<AccountDetailsProps> = ({
    account,
}) => {
    const integrationAccount = account.integrationAccounts?.[0];
    const companyMetadata =
        integrationAccount?.metadata as GustoConnectedCompanyMetadata;
    if (!companyMetadata) {
        return null;
    }
    return (
        <>
            <AccountDetailsField title="Company name">
                {companyMetadata.name}
            </AccountDetailsField>
            <AccountDetailsField title="EIN">
                {companyMetadata.ein}
            </AccountDetailsField>
        </>
    );
};
